import axios from "axios"
import { ACTIVE_TAB, LOADER_STATUS, FILE_DATA, FILTER_DATA_JW, SET_ENTITY_LIST, PROFILE_DATA, JWT_GSTIN_DATA, ORG_CHALLAN_DATA, NEW_CHALLAN_DATA, INVOICE_DATA, DEFAULT_SELECT_PERIOD, DEFAULT_FREQUENCY, DEFAULT_GSTIN, DEFAULT_ENTITY } from "./constants";
import { getLocalStorage } from "components/Helper/Helper";
import { Config } from "../../../Config.js";
import { toast } from "react-toastify";

function errNot(msg) {
  toast.success(`${msg}`, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}
function errNotError(msg) {
  toast.error(`${msg}`, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}
const handlemonth = (value) => {
  const dateString = value;
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Month is zero-based, so we add 1
  let temp = month < 10 ? 0 + month.toString() : month
  const resultDate = temp.toString() + year.toString();
  return resultDate;
}
const convertToIST = (dateTimeString) => {
  try {
    if(!dateTimeString)
    {
      return null
    }
    const date = new Date(dateTimeString);
    const options = {
      timeZone: 'Asia/Kolkata', // Set timezone to IST
      hour12: false, // Use 24-hour format
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',

    };
    return date.toLocaleString('en-IN', options).replace(",", "").replace("/","-").replace("/","-");
  } catch {
    return null
  }

};

export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
}
// action creator
export function setViewData(fileData) {
  return {
    type: FILE_DATA,
    fileData: fileData,
  };
}


//-----------------------------------------------------------
export function setJwtGSTINData(data) {
  return {
    type: JWT_GSTIN_DATA,
    data: data,
  };
}
export function setOrgChallanData(data) {
  return {
    type: ORG_CHALLAN_DATA,
    data: data,
  };
}
export function setNewChallanData(data) {
  return {
    type: NEW_CHALLAN_DATA,
    data: data,
  };
}
export function setInvoiceData(data) {
  return {
    type: INVOICE_DATA,
    data: data,
  };
}
//-----------------------------------------------------------
export function setfilterDataJW(filterDataJW) {
  return {
    type: FILTER_DATA_JW,
    filterDataJW: filterDataJW,
  }
}
export function setEntityList(data) {
  return {
    type: SET_ENTITY_LIST,
    payload: data,
  }
};

export function profileInfo(payload) {
  return {
    type: PROFILE_DATA,
    profileData: payload,
  };
};

export function setDefaultEntity(payload) {
  return {
    type: DEFAULT_ENTITY,
    data: payload,
  };
};

export function setDefaultGstin(payload) {
  return {
    type: DEFAULT_GSTIN,
    data: payload,
  };
};

export function setDefaultFrequency(payload) {
  return {
    type: DEFAULT_FREQUENCY,
    data: payload,
  };
};

export function setDefaultSelectPeriod(payload) {
  return {
    type: DEFAULT_SELECT_PERIOD,
    data: payload,
  };
};

//  middleware k thorugh redux
export function getViewTableData(activeTab, selectedGSTIN, startDateRpt, endDateRpt, jwtGstin, challanNumber, invoiceNumber, startDate, endDate) {
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      type: activeTab == "1" ? "table4" : activeTab == "2" ? "table5A" : activeTab == "3" ? "table5B" : "table5C",
      startFrom: "1",
      takeData: "10",
      rpt_from: handlemonth(startDateRpt),
      rpt_to: handlemonth(endDateRpt),
      gstin_filter: selectedGSTIN.join(','),
      jw_ctin_filter: jwtGstin.join(','),
      ctin_values: invoiceNumber.join(','),
      chnum_values: challanNumber.join(','),
      fromDate_filter:convertToIST(startDate) ,
      toDate_filter:convertToIST(endDate)
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${Config.url}itc04/uploadHistory`,
        params: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            let Id = response.data?.data?.map((item) => {
              return { ...item, id: item.gstin + "," + item.rpt }
            })
            resolve(Id);
            dispatch(setViewData(Id));
          } else {
            resolve([])
            errNotError(response.data.message);
            dispatch(setViewData([]));
          }
          dispatch(loader(false));

        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
}

export function getFilters(activeTab, filterType, startDate, toDate) {
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      type: activeTab == "1" ? "table4" : activeTab == "2" ? "table5A" : activeTab == "3" ? "table5B" : "table5C",
      rpt_from: handlemonth(startDate),
      rpt_to: handlemonth(toDate),
      filterType: filterType,
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}itc04/getFilters`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          console.log("responseOfDAta", filterType, response.data)
          if (response.data.error != 1) {
            if (response?.data?.data && Array.isArray(response.data.data)) {
              let modifiedResponse = response.data.data.filter(item=> {
                return item != null
              })
              let mapedData = modifiedResponse.map((item) => { return { title: item, value: item } })
              
              if (filterType === "ino_number") {
                dispatch(setInvoiceData(mapedData));
              } else if (filterType === "cha_number") {
                dispatch(setOrgChallanData(mapedData));
              } else if (filterType === "jo_gstin") {
                dispatch(setJwtGSTINData(mapedData));
              }
            } else {
              if (filterType === "ino_number") {
                dispatch(setInvoiceData([]));
              } else if (filterType === "cha_number") {
                dispatch(setOrgChallanData([]));
              } else if (filterType === "jo_gstin") {
                dispatch(setJwtGSTINData([]));
              }
            }

            resolve([]);
          } else {
            resolve([])
            if (filterType === "ino_number") {
              dispatch(setInvoiceData([]));
            } else if (filterType === "cha_number") {
              dispatch(setOrgChallanData([]));
            } else if (filterType === "jo_gstin") {
              dispatch(setJwtGSTINData([]));
            }

          }
          dispatch(loader(false));

        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          resolve([])
        });
    });
  };
}
export function deleteSelectedRecords(selected, activeTab, startDate, endDate) {
  return (dispatch) => {
    dispatch(loader(true));
    let rpt_from = handlemonth(startDate);
    let rpt_to = handlemonth(endDate);
    let data = {
      type: activeTab == "1" ? "table4" : activeTab == "2" ? "table5A" : activeTab == "3" ? "table5B" : "table5C",
      selected: selected,
      rpt_from: rpt_from,
      rpt_to: rpt_to,
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}itc04/deleteData`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            errNot(response.data.message);
          }
          else {
            errNotError(response.data.message);
          }
          dispatch(loader(false));
          resolve(true)
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          resolve(false);
        });
    });
  };
}

export const viewDataDownload = (selected, activeTab, startDateRpt, endDateRpt, ctin, chnum, jw_ctin, fromDate, toDate,selectedGSTIN) => {
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      type: activeTab == "1" ? "table4" : activeTab == "2" ? "table5A" : activeTab == "3" ? "table5B" : "table5C",
      selected: selected,
      rpt_from: handlemonth(startDateRpt),
      rpt_to: handlemonth(endDateRpt),
      ctin_values: ctin.join(','),
      chnum_values: chnum.join(','),
      gstin_filter:selectedGSTIN.join(','),
      jw_ctin_filter: jw_ctin.join(','),
      fromDate_filter:convertToIST(fromDate) ,
      toDate_filter:convertToIST(toDate)
    }
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        data: data,
        url: `${Config.url}itc04/downloadUploadHistory`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
        responseType: "blob",
      })
        .then((response) => {
          errNot("Data Downloaded Successfully");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "ITC_04_View_Data.xlsx");
          document.body.appendChild(link);
          link.click();
          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          reject(true);
        });
    });
  };
};
export function setActiveTabId(id) {
  return {
    type: ACTIVE_TAB,
    tabId: id,
  }
}
export const filterGstinJW = () => {
  let data = {
    jo_gstin: "",
    type: "table4",
    filterType: "jo_gstin"
  };
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        data: data,
        url: `${Config.url}itc04/getFilters`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            resolve(true);
            dispatch(setfilterDataJW(response.data.data))
          } else {
            resolve(false);
            dispatch(setfilterDataJW([]))

          }
          dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};

export const filterChallanJW = () => {
  let data = {
    jo_gstin: ""
  };
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        data: data,
        url: `${Config.url}itc04/getFilters`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            resolve(true);
          } else {
            resolve(false);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};

export const filterChallanPrincipal = () => {
  let data = {
    jo_gstin: ""
  };
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        data: data,
        url: `${Config.url}itc04/getFilters`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            resolve(true);
          } else {
            resolve(false);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
export function getEntityList() {
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      user_id: getLocalStorage("user_id").user_id
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getCompanyByUserId`,
        data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            let entityList = response.data.data.map((entity) => {
              return { value: entity.company_id, label: entity.name }
            });
            dispatch(setEntityList(entityList));

            resolve(true);
          } else {
            resolve([]);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  }
};

export const getGstinByEntity = (value) => {

  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      entity_id: value,
      user_id: getLocalStorage("user_id").user_id

    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getGstnListByEntityId`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {


            if (response.data?.data?.length > 0) {

              const sortedGstin = response.data.data.sort((a, b) =>
                a.gstin > b.gstin ? 1 : -1
              );
              dispatch(profileInfo(sortedGstin));
            } else {
              dispatch(profileInfo([]));
            }
          }

          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};